.comment {
  margin: 1rem 0;
  padding: 1rem;
  border: 1px solid var(--color-muted);
  border-radius: 8px;
}

.preserveWhitespace {
  white-space: pre-wrap;
}
